import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "../context/AuthContext";
import Seo from "../components/Seo";
import { useLanguage } from "../context/LanguageContext";

export default function Categories() {
  const { t } = useLanguage();
  const [cats, setCats] = useState([]);
  useEffect(() => { axios.get(`${API}/categories`).then(r => setCats(r.data)); }, []);

  return (
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-12">
      <Seo
        title="Categorie Aste — 7 Specializzazioni Curate"
        description="Le aste Rarium sono organizzate in sette categorie curate da esperti: aste d'arte, aste di orologi, aste di gioielli, aste di auto classiche, aste di vini, aste di monete e aste di libri rari."
        path="/categories"
      />
      <div className="overline text-stone-500">{t("Il catalogo")}</div>
      <h1 className="font-serif text-5xl sm:text-6xl tracking-tighter mt-2">{t("Sette specializzazioni.")}</h1>
      <p className="mt-4 text-stone-600 max-w-2xl">{t("Ogni categoria è affidata a un curatore indipendente con oltre 10 anni di esperienza sul mercato di riferimento.")}</p>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-1">
        {cats.map((c, i) => (
          <Link
            key={c.slug}
            to={`/category/${c.slug}`}
            data-testid={`cat-${c.slug}`}
            className="group relative aspect-[4/5] overflow-hidden fade-up"
            style={{ animationDelay: `${i * 80}ms` }}
          >
            <img src={c.image} alt={c.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
            <div className="absolute inset-x-0 bottom-0 p-6">
              <div className="overline text-[#B49A5F]">{t("Categoria ")}0{i+1}</div>
              <div className="font-serif text-3xl text-stone-50 mt-2">{c.name}</div>
              <div className="mt-4 inline-flex items-center gap-2 text-stone-50 text-sm underline-hover">
                {t("Vedi i lotti →")}
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
